/**
 * Web implementation: no-op.
 *
 * The default implementation (crashLogger.ts) forwards socket.io connection
 * diagnostics to Firebase Crashlytics. Crashlytics has no web SDK, so on web
 * builds (client/preview via webpack) this `.web.ts` file is resolved instead,
 * keeping `@react-native-firebase/crashlytics` out of the web bundle entirely.
 */
export const logSocketDiagnostic = (
  _message: string,
  _error?: unknown,
  _appId?: string
): void => {
  // no-op on web
};

export const recordError = (_error: unknown, _appId?: string): void => {
  // no-op on web
};
